/**
 * plainWeave 相关的常量定义
 */

/** HTML 元素标签 */
export const HTML标签_CANVAS = 'canvas'

/** Canvas 上下文类型 */
export const CANVAS上下文_2D = '2d'

/** 错误消息 */
export const 错误消息_无法获取2D上下文 = 'Could not get 2d context'
export const 错误消息_纹理转Blob失败 = 'Failed to convert texture to Blob'

/** 图像格式 */
export const MIME类型_PNG = 'image/png'

/** GPU 缓冲区对齐 */
export const GPU缓冲区对齐 = 256
export const 每像素字节数 = 4
